module.exports = __webpack_public_path__ + "8195aec1f4b26e73fbd5007a56743228.pdf";